import { useMemo, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { UsersReportAPI } from 'api/users-report';
import { Filter } from 'components/molecules/filters/types';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { UsersReport } from 'components/organisms/users-report/types';
import { Empty, Loaded, Loading } from 'stores/core';

export const useUsersReport = (
  range: DateRange,
  { criteria, type }: Filter,
  isInitialized: boolean,
): UsersReport => {
  const [usersReport, setUsersReport] = useState<UsersReport>(Loading());

  const validFilters = useMemo(
    () => criteria.filter(FieldFilter.isValid),
    [criteria],
  );

  useDeepCompareEffect(() => {
    if (!isInitialized) {
      return;
    }
    setUsersReport(Loading());

    UsersReportAPI.getReports(range, validFilters, type).then((records) =>
      records.length > 0
        ? setUsersReport(Loaded(records))
        : setUsersReport(Empty()),
    );
  }, [range, type, validFilters, isInitialized]);

  return usersReport;
};
